module.exports = __webpack_public_path__ + "img/troca_para_editor_html.4307d811.png";